import api from '@/api'

export default {
    namespaced: true,
    state: {},
    actions: {
        /**
         * NOTE: 申請加入學校
         * @return {Object}
         */
        async applySchool({dispatch, rootState}, schoolCode) {
            // 檢查是否需要重置AccessToken
            await dispatch('coreApi/refreshAccessToken', null, {root: true})
            return new Promise(function(resolve) {
                api.ies5Api.applySchool(rootState.coreApi.tokens, schoolCode).then(() => {
                    resolve(true)
                }).catch(() => {
                    resolve(true)
                })
            })
        },
    },
}